module.exports = __webpack_public_path__ + "img/bImg5.fbd24cc1.png";